import React from 'react'
import styles from './Divider.module.scss'
import { DividerProps } from './Divider.types'

const Divider = (
  {
    value,
  }: DividerProps) => {
  return (
    <div className={styles.divider}>
      <hr/>
      <p className={styles.value}>
        {value}
      </p>
    </div>
  )
}

export default Divider